import { useSelector } from 'react-redux';


export const useFooterData = () => {
  const subInfoForBanners = useSelector(store => store.footerReducer);

  return {
    subInfoForBanners,
  }
};